import { gql } from '@apollo/client';

export const REQUEST_DATA_EXPORT = gql`
  mutation requestDataExport($include: [String!]) {
    requestDataExport(include: $include) {
      success
      message
      token
    }
  }
`;
